import Radium, { StyleRoot } from "radium";
import {
  bounce,
  bounceIn,
  fadeIn,
  shake,
  flipInX,
  flipInY,
  slideInRight,
} from "react-animations";

const styles = {
  bounce: {
    animation: "x 1s",
    animationName: Radium.keyframes(bounce, "bounce"),
  },
  bounceIn: {
    animation: "x 1s",
    animationName: Radium.keyframes(bounceIn, "bounceIn"),
  },
  fadeIn: {
    animation: "x 1s",
    animationName: Radium.keyframes(fadeIn, "fadeIn"),
  },
  shake: {
    animation: "x 1s",
    animationName: Radium.keyframes(shake, "shake"),
  },
  flipInX: {
    animation: "x 1s",
    animationName: Radium.keyframes(flipInX, "flipInX"),
  },
  flipInY: {
    animation: "x 1s",
    animationName: Radium.keyframes(flipInY, "flipInY"),
  },
  slideInRight: {
    animation: "x 1s",
    animationName: Radium.keyframes(slideInRight, "slideInRight"),
  },
};

const Animations = ({ children, name = "bounce" }) => {
  return (
    <StyleRoot>
      <div style={styles[name]}>{children}</div>
    </StyleRoot>
  );
};

export default Animations;
